import styled from 'styled-components'

import { Colors } from '@fourthwall/components'

export const Container = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;

  &:before,
  &:after {
    content: '';
    flex: 1 1;
    border-bottom: 1px solid ${Colors.GS400};
    margin: auto;
  }
`

export const Label = styled.div`
  margin: 0 8px;

  color: ${Colors.GS600};
  font-size: 10px;
  text-transform: uppercase;
  letter-spacing: 1px;
`
